<template>
  <div
    class="fact-card-skeleton mb-6 border border-n-slate-3 dark:border-n-slate-8 rounded-lg p-6 bg-white dark:bg-n-slate-2 shadow-sm"
  >
    <!-- Header skeleton with fact label and delete button -->
    <div class="flex justify-between items-center mb-4">
      <!-- Fact label skeleton -->
      <div
        class="skeleton-element bg-n-slate-3 dark:bg-n-slate-7 px-2 py-1 rounded w-16 h-6"
      />

      <!-- Delete button skeleton -->
      <div class="flex gap-2">
        <div
          class="skeleton-element bg-n-slate-3 dark:bg-n-slate-7 w-8 h-8 rounded"
        />
      </div>
    </div>

    <!-- Editor Content skeleton -->
    <div
      class="fact-editor-container-skeleton bg-white dark:bg-n-slate-1 rounded-lg border border-n-slate-3 dark:border-n-slate-6 p-3"
    >
      <!-- Simulated text lines in the editor -->
      <div class="space-y-2">
        <div
          class="skeleton-element bg-n-slate-2 dark:bg-n-slate-6 h-4 w-full rounded"
        />
        <div
          class="skeleton-element bg-n-slate-2 dark:bg-n-slate-6 h-4 w-4/5 rounded"
        />
        <div
          class="skeleton-element bg-n-slate-2 dark:bg-n-slate-6 h-4 w-3/4 rounded"
        />
        <div
          class="skeleton-element bg-n-slate-2 dark:bg-n-slate-6 h-4 w-2/3 rounded"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.fact-card-skeleton {
  transition: all 0.2s ease;
  min-height: 200px;
}

.fact-editor-container-skeleton {
  position: relative;
  min-height: 120px;
}

.skeleton-element {
  animation: skeleton-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes skeleton-pulse {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

/* Dark mode adjustments */
@media (prefers-color-scheme: dark) {
  .skeleton-element {
    opacity: 0.3;
  }
}
</style>
